// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "app.walletnow",
    name: "NOW Wallet",
    homepage: "https://walletnow.app/",
    image_id: "b6ee4efc-f53e-475b-927b-a7ded6211700",
    app: {
        browser: null,
        ios: "https://apps.apple.com/app/now-wallet-bitcoin-crypto/id1591216386",
        android: "https://play.google.com/store/apps/details?id=com.nowwallet",
        mac: "https://apps.apple.com/app/now-wallet-bitcoin-crypto/id1591216386",
        windows: "https://apps.microsoft.com/detail/xpdc4v0j3zkvhh",
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "nowwallet://",
        universal: "https://walletnow.app.link",
    },
    desktop: {
        native: "nowwallet://",
        universal: "https://walletnow.app.link",
    },
};
//# sourceMappingURL=index.js.map